import { LightningService } from '../../services/lightning/Lightning';
import { useEffect } from 'react';
import { useMap, useMapEvents } from 'react-leaflet';
import './Lightning.css'


export const Lightning = () => {
    const map = useMap();
    let service: LightningService | null = null;

    
    const init = async () => {
         service = new LightningService(map);
         await service.getLightning();
        service.startObservation();
    }
    useMapEvents({
        zoom: (event) => {
            if (service) {
                service.updateFrame();
            }
        },
        move: (event) => {
            if (service) {
                service.updateFrame();
            }
        }
    })

    useEffect(() => {
        init();

        return () => {
            if (service) {
                service.stopObservation();
            }
        };
    }, []);
    
    return <></>
    
}
